import { Badge } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import { referenceTypes, ticketWorklistId } from '../../../utils/app-configs';
import { setPromptInfo } from '../containers/navigation-actions';
import { Item, TextWrapper } from './menu-item';

const StyledBadge = styled(Badge)`
  .ant-badge-dot {
    width: 10px;
    height: 10px;
    margin-top: -1px;
    margin-right: -7px;
  }
  div {
    color: ${p => p.active ? p.theme.colors.theme : 'rgba(0, 0, 0, 0.88)'};
  }
`;

const StyledItem = styled(Item)`
  .active span {
    color: ${p => p.theme.colors.theme};
  }
`;

const getActiveStyle = theme => ({
  color: theme.colors.theme,
  borderBottomColor: theme.colors.theme,
});

const TicketMenuItem = ({
  type,
  link,
  theme,
  active = false,
  count: hasIcon,
  id,
  getWorklistData,
  baseType,
}) => {
  const dispatch = useDispatch();
  const { isNavigationBlocked, promptInfo } = useSelector(state => state.navigation);

  useEffect(() => {
    getWorklistData({
      id: ticketWorklistId,
      urlString: 'status||1;2',
      objectId: baseType === referenceTypes.installedAt ? `showChildren[${id}]` : id,
      needsGeoJson: false,
      shouldUpdateCount: true,
    });
  }, []);

  const checkIfActive = () => {
    if (link.includes('/tickets')) {
      return location.pathname.includes('/tickets');
    }

    return decodeURIComponent(location.pathname).includes(
      decodeURIComponent(link),
    );
  };

  const navigate = (e) => {
    if (isNavigationBlocked) {
      e.preventDefault();
      if (!promptInfo) {
        dispatch(setPromptInfo({
          url: link,
        }));
      }
    }
  };
  const isActiveMenu = checkIfActive();
  return (
    <StyledItem data-test-id='nav.subNav.TICKETS'>
      <NavLink
        to={link}
        onClick={navigate}
        style={({ isActive }) =>
          isActive || isActiveMenu ?
            // eslint-disable-next-line no-undefined
            getActiveStyle(theme) : undefined
        }
        isActive={active || isActiveMenu ? () => true : null}
      >
        <StyledBadge dot={hasIcon} active={active || isActiveMenu}>
          <TextWrapper>{type}</TextWrapper>
        </StyledBadge>
      </NavLink>
    </StyledItem>
  );
};
TicketMenuItem.propTypes = {
  type: PropTypes.string,
  link: PropTypes.string,
  theme: PropTypes.object,
  active: PropTypes.bool,
  count: PropTypes.number,
  id: PropTypes.string,
  getWorklistData: PropTypes.func,
  baseType: PropTypes.string,
};

export default withTheme(TicketMenuItem);
